import React from 'react';

/** Main scroll area below sticky top nav */
export function PageContainer({ children, className = '', dir }) {
  return (
    <div
      dir={dir}
      className={`mx-auto w-full max-w-6xl px-4 pb-16 pt-8 sm:px-6 sm:pt-10 lg:px-10 ${className}`}
    >
      {children}
    </div>
  );
}
